<div class="wrapper">
  <span #contents class="message"></span>
  <div class="actions">
    @for (button of buttons; track button) {
      <button class="button" color="primary" mat-button (click)="goto(button.link)">{{button.label}}</button>
    }
    <button class="button" color="primary" mat-button (click)="close()">Close</button>
  </div>
</div>
